module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"padded\">\n	<table class=\"form-table\">\n		<tr>\n			<td colspan=\"2\" class=\"meta-contact-phone\">\n				<button on-click=\"addPhone\">Добавить номера контактых телефонов</button>\n			</td>\n		</tr>\n		<tr>\n			<td colspan=\"2\" class=\"meta-contact-address\"><button on-click=\"addAddress\">Добавить адрес</button></td>\n		</tr>\n		<tr>\n			<td colspan=\"2\" class=\"meta-contact-onlineresource\">\n				<button on-click=\"addOnlineResource\">Добавить интернет-ресурс</button>\n			</td>\n		</tr>\n		<tr>\n			<td>Время (включая часовой пояс)</td>\n			<td><control type=\"text\" target=\"item.hours\"/></td>\n		</tr>\n		<tr>\n			<td>Дополнительные сведения</td>\n			<td><control type=\"text\" target=\"item.instructions\"/></td>\n		</tr>\n	</table>\n</div>\n")
  }
  return __output.join("");

}